const getImages = (store) => {
  return {
    images: store.root.imagesStore.images || [],
    lastUsedCategoryId: store.category.categoryStore.lastUsedCategoryId || '',
  };
};

const getActiveCategory = (store) => {
  return {
    categoryId: store.root.imagesStore.categoryId,
  };
};

module.exports = {
  getImages,
  getActiveCategory,
};
